export default "__VITE_ASSET__BPseJgnp__"